import { getModuleData } from '../services/businessCommonService';

export interface IConfig {
    basic: {
        logo: string;
        enterpriseName: string;
        appIcon: string;
        appName: string;
        hideFooter: number;
        hideHeadTitle: number;
    };
    moduleA?: {
        //
    };
}

class ConfigManager {
    public getConfig() {
        return {
            basic: this.getBasic(),
        };
    }

    private getBasic() {
        // 待补充类型
        const info = getModuleData('contextInfo', 'enterprise_info');
        const config = info.config || {};
        const appInfo = this.getAppInfo();
        return Object.assign(
            {
                logo: this.formatImage(info.logo_mobile || info.logo || '', { width: 120 }),
                enterpriseName: config.enterprise_name,
                hideFooter: config.hide_footer,
                hideHeadTitle: config.hide_head_title,
            },
            appInfo,
        );
    }

    private formatImage(url: string, options: { width: number }) {
        if (/w_$/.test(url)) {
            return `${url}${options.width}`;
        }
        return url;
    }

    private getAppInfo() {
        const info = getModuleData('contextInfo', 'enterprise_info');
        const config = info.config || {};
        const appInfo = {
            appIcon: '',
            appName: 'UMU',
        };

        return appInfo;
    }
}

export default new ConfigManager();
